import {  BadgeCheck, BookOpen, BoxesIcon, BoxIcon, FileText, FolderTree, Home, Image, Mail, MessageCircle, Package, Settings, Send, Share, Share2, Shield, ShoppingBag, Star, UserKey, UserLockIcon, Users, Users2Icon, UsersIcon, BadgeQuestionMark } from "lucide-react";
import { SideBarItem } from "./SideBarItem";
import { ROUTE_PATHS } from "../../../../constants/routeConstants";

export const ROUTE_CONFIG = {
  DASHBOARD: { path: ROUTE_PATHS.DASHBOARD, label: "Dashboard" },
  USERS: { path: ROUTE_PATHS.USERS, label: "Users" },
  ROLES: { path: ROUTE_PATHS.ROLES, label: "Roles" },
  ASSIGN_PERMISSIONS: { path: ROUTE_PATHS.ASSIGN_PERMISSIONS, label: "Assign Permissions" },
  BRAND: { path: ROUTE_PATHS.BRAND, label: "Brands" },
  PRODUCT_CATEGORY: { path: ROUTE_PATHS.PRODUCT_CATEGORY, label: "Categories" },
  PRODUCT_SUB_CATEGORY: { path: ROUTE_PATHS.PRODUCT_SUB_CATEGORY, label: "Sub Categories" },
  PRODUCT: { path: ROUTE_PATHS.PRODUCT, label: "Products" },
  BANNER: { path: ROUTE_PATHS.BANNER, label: "Banners" },
  BLOG_CATEGORY: { path: ROUTE_PATHS.BLOG_CATEGORY, label: "Blog Categories" },
  BLOG: { path: ROUTE_PATHS.ADMIN_BLOG, label: "Blogs" },
  REVIEWS: { path: ROUTE_PATHS.REVIEWS, label: "Reviews" },
  CONTACT_MESSAGES: { path: ROUTE_PATHS.CONTACT_MESSAGES, label: "Contact Messages" },
  SUBSCRIBERS_LIST: { path: ROUTE_PATHS.SUBSCRIBERS_LIST, label: "Newsletter Subscribers" },
  CREATE_USER: { path: ROUTE_PATHS.CREATE_USER, label: "Create User" },
  FAQs: {path:ROUTE_PATHS.FAQS_LIST, label : "FAQs" }
};


const SideBarData = () => {
  return <>
    
    <SideBarItem link={ROUTE_CONFIG.DASHBOARD.path}
     noPermission={true} 
     text={ROUTE_CONFIG.DASHBOARD.label} 
     icon={<Home />} />
    
    <SideBarItem link={ROUTE_CONFIG.USERS.path} text={ROUTE_CONFIG.USERS.label} 
    module={"user"} 
    permission={"read_user"}
     icon={<Users />} />

    <SideBarItem module={"role"} permission={"read_role"}
      link={ROUTE_CONFIG.ROLES.path}
      text={ROUTE_CONFIG.ROLES.label}
      icon={<Shield  />}
    />
    <SideBarItem module={"permission"} permission={"assign_permission"}
      link={ROUTE_CONFIG.ASSIGN_PERMISSIONS.path}
      text={ROUTE_CONFIG.ASSIGN_PERMISSIONS.label}
      icon={<UserLockIcon />}
    />
    <SideBarItem module={"banner"} permission={"read_banner"}
      link={ROUTE_CONFIG.BANNER.path}
      text={ROUTE_CONFIG.BANNER.label}
      icon={<Image  />}
    />
    
    <SideBarItem module={"product_category"} permission={"read_product_category"}
      link={ROUTE_CONFIG.PRODUCT_CATEGORY.path}
      text={ROUTE_CONFIG.PRODUCT_CATEGORY.label}
      icon={<Package  />}
    />
    
    <SideBarItem module={"product_subcategory"} permission={"read_product_subcategory"}
      link={ROUTE_CONFIG.PRODUCT_SUB_CATEGORY.path}
      text={ROUTE_CONFIG.PRODUCT_SUB_CATEGORY.label}
      icon={<FolderTree />}
    />
    <SideBarItem module={"brand"} permission={"read_brand"}
      link={ROUTE_CONFIG.BRAND.path}
      text={ROUTE_CONFIG.BRAND.label}
      icon={<BadgeCheck  />}
    />
    <SideBarItem module={"product"} permission={"read_product"}
      link={ROUTE_CONFIG.PRODUCT.path}
      text={ROUTE_CONFIG.PRODUCT.label}
      icon={<ShoppingBag  />}
    />
    <SideBarItem module={"blog_category"} permission={"read_blog_category"}
      link={ROUTE_CONFIG.BLOG_CATEGORY.path}
      text={ROUTE_CONFIG.BLOG_CATEGORY.label}
      icon={<BookOpen  />}
    />
    <SideBarItem module={"blog"} permission={"read_blog"}
      link={ROUTE_CONFIG.BLOG.path}
      text={ROUTE_CONFIG.BLOG.label}
      icon={<FileText />}
    />
    <SideBarItem module={"faqs"} permission={"read_faqs"}
      link={ROUTE_CONFIG.FAQs.path}
      text={ROUTE_CONFIG.FAQs.label}
      icon={<BadgeQuestionMark />}
    />
    <SideBarItem noPermission
      link={ROUTE_CONFIG.REVIEWS.path}
      text={ROUTE_CONFIG.REVIEWS.label}
      icon={<Star />}
    />
    <SideBarItem module={"contact"} permission={"read_contact"}
      link={ROUTE_CONFIG.CONTACT_MESSAGES.path}
      text={ROUTE_CONFIG.CONTACT_MESSAGES.label}
      icon={<MessageCircle />}
    />
    <SideBarItem module={"subscriber"} permission={"read_subscriber"}
      link={ROUTE_CONFIG.SUBSCRIBERS_LIST.path}
      text={ROUTE_CONFIG.SUBSCRIBERS_LIST.label}
      icon={<Mail  />}
    />
    <SideBarItem noPermission
      link={ROUTE_PATHS.EMAIL_TEMPLATES}
      text="Email Templates"
      icon={<Send />}
    />
     <SideBarItem  link={ROUTE_PATHS.SETTINGS} adminPermission text="Settings" icon={<Settings />} />
  </>
}
export default SideBarData;